import { get } from 'lodash'
import { required, email } from 'utils/validation'

const validate = values => {
  return {
    helpers: {
      category: required(get(values, 'helpers.category')),
      subcategory: required(get(values, 'helpers.category'))
    },
    activityCategory: {
      id: required(get(values, 'activityCategory.id'))
    },
    aim: required(get(values, 'aim')),
    assessorTitle: required(get(values, 'assessorTitle')),
    assessorName: required(get(values, 'assessorName')),
    assessorEmail: required(get(values, 'assessorEmail')) || email(get(values, 'assessorEmail'))
  }
}

export default validate
